import {useHarmonicIntervalFn} from 'react-use'

import VisuallyHidden from '@/utils/a11y/VisuallyHidden'
import style from '@/views/Home/components/HomePageFlashDeals/HomePageFlashDeals.module.scss'

interface Props {
  remainingSeconds: number
}

export default memo<Props>(function Timer(props) {
  const [remainingSeconds, setRemainingSeconds] = useState(props.remainingSeconds)

  useHarmonicIntervalFn(() => {
    setRemainingSeconds(prev => prev - 1)
  }, 1000)

  const {days, hours, minutes, seconds} = (() => {
    const days = Math.floor(remainingSeconds / 86400)
    const hours = Math.floor((remainingSeconds % 86400) / 3600)
    const minutes = Math.floor((remainingSeconds % 3600) / 60)
    const seconds = Math.floor(remainingSeconds % 60)
    return {days, hours, minutes, seconds}
  })()

  if (remainingSeconds <= 0) return null

  return (
    <>
      <VisuallyHidden>
        {days > 0 && `${days} days, `}
        {hours} hours, {minutes} minutes, {seconds} seconds{' '}
      </VisuallyHidden>
      <div className={style.FlashDealsTimer} aria-hidden>
        {days > 0 && (
          <div aria-hidden>
            <div className={style.TextSup} aria-hidden>
              {days}
            </div>
            <div className={style.TextSub} aria-hidden>
              Day{days > 1 ? 's' : ''}
            </div>
          </div>
        )}
        <div aria-hidden>
          <div className={style.TextSup} aria-hidden>
            {hours}
          </div>
          <div className={style.TextSub} aria-hidden>
            Hour{hours > 1 ? 's' : ''}
          </div>
        </div>
        <div aria-hidden>
          <div className={style.TextSup} aria-hidden>
            {minutes}
          </div>
          <div className={style.TextSub} aria-hidden>
            Minute{minutes > 1 ? 's' : ''}
          </div>
        </div>
        <div aria-hidden>
          <div className={style.TextSup} aria-hidden>
            {seconds}
          </div>
          <div className={style.TextSub} aria-hidden>
            Second{seconds > 1 ? 's' : ''}
          </div>
        </div>
      </div>
    </>
  )
})
